import { MobileCompetitionRegistrationModalComponent } from './../mobile-competition-registration-modal/mobile-competition-registration-modal.component';
import { NgbModal, NgbModalRef, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { TournamentWithAccountId } from "../../../api/DixApiClient";
import { competitionRegistrationModal } from "./competitionRegistration.component";

export function ShowCompetitionRegisterModal(modalService: NgbModal, competition:TournamentWithAccountId | null, isViewDetails = false, isUser = false, successMessage = false, firstLogin=false, dismissWindow = false, mobileMode = 'desktop') {
    const mobile = mobileMode != 'desktop';
    const component = mobile? MobileCompetitionRegistrationModalComponent: competitionRegistrationModal;
    const windowClass = "dark-modal" + (mobile? ' mobile': '');

    let windowsize:any = "sm";
    if(competition==null)
    {
        windowsize = "lg"
    }

    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: windowClass,
        size: windowsize
    };
    let m: NgbModalRef = modalService.open(component, opt);
    let modal = (<competitionRegistrationModal>m.componentInstance);
    
    modal.competition = competition;
    modal.isViewDetails = isViewDetails;
    modal.isUser = isUser;
    modal.successMessage = successMessage;
    modal.firstLogin = firstLogin;
    modal.dismissWindow = dismissWindow;
    modal.funnelLogin = competition == null?true:false;
    return modal;
}
